<template>
    <div id="mission">
        <b-container>
            <b-row>
                <b-col class="text-center">
                    <p class="title">{{ $t('mission.title') }}</p>
                    <p>{{ $t('mission.subtitle') }}</p>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
#mission{
    padding-top: 250px;
}
p{
    font-size: 45px;
    font-weight: 300;
    line-height: 1;
    max-width: 65%;
    margin: auto;
}
.title{
    font-weight: 400;
    margin-bottom: 0;
}

@media (max-width: 768px){
    #mission{
        padding-top: 100px;
    }
    p{
        font-size: 35px;
        max-width: 85%;
    }
}
</style>